import { render, staticRenderFns } from "./salary_match_config_edit.vue?vue&type=template&id=59d02436&scoped=true"
import script from "./salary_match_config_edit.vue?vue&type=script&lang=js"
export * from "./salary_match_config_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d02436",
  null
  
)

export default component.exports